import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { AppServices } from 'services/AppServices';
import { Spinner } from '../common/Spinner';
import { Content } from 'models/Content';
import { ContentItem } from './ContentItem';
import { ContentDetailsView } from './ContentDetailsView';
import Locale from 'localization/Localization';
import { Layout } from 'components/common/Layout';
import { UserConsumer } from 'components/contexts/UserContext';
import { Button } from 'react-bootstrap';

interface ContentPageState {
	contentDownloadFinished: boolean;
	contentDownloadSuccessful: boolean;
	contents: Array<Content>;
	selectedContent: Content | undefined;
}

export class ContentPage extends React.Component<RouteComponentProps<{}>, ContentPageState>
{
	constructor(props: RouteComponentProps<{}>) {
		super(props);

		this.state = {
			contentDownloadFinished: false,
			contentDownloadSuccessful: false,
			contents: new Array<Content>(),
			selectedContent: undefined
		};

		this.onContentDetailsViewBackClicked = this.onContentDetailsViewBackClicked.bind(this);
		this.onContentItemClicked = this.onContentItemClicked.bind(this);
		this.onContentEdit = this.onContentEdit.bind(this);
		this.getContent = this.getContent.bind(this);
	}

	public componentDidMount() {

		document.title = Locale.getPageTitle('page_content');

		// Is any specific content to be selected?
		let id: string | undefined;
		if (this.props.location.state !== undefined &&
			this.props.location.state !== null) {
			id = (this.props.location.state as any).id;
		}

		this.getContent()
			.then((content: Array<Content>) => {
				const selected = id === undefined
					? undefined
					: content.find(x => x.contentId === id);

				this.setState({
					selectedContent: selected
				});
			})
			.catch(console.error);
	}

	private async getContent(): Promise<Array<Content>> {

		this.setState({ contentDownloadFinished: false });

		return AppServices.contentService.getContent()
			.then((content: Array<Content>) => {
				this.setState({
					contentDownloadFinished: true,
					contentDownloadSuccessful: true,
					contents: content
				});
				return content;
			})
			.catch(() => {
				this.setState({
					contentDownloadFinished: true,
					contentDownloadSuccessful: false
				});
				return [];
			});
	}

	private onContentItemClicked(item: Content) {
		this.setState({
			selectedContent: item
		});
	}

	private onContentDetailsViewBackClicked() {
		this.setState({
			selectedContent: undefined
		});

		this.getContent();
	}

	private onContentEdit() {
		console.log("onEdit");
		this.props.history.push(
			'/content/edit',
			{
				content: this.state.selectedContent
			}
		);
	}

	public render() {
		let pageContent: JSX.Element;

		if (this.state.contentDownloadFinished === false) {
			pageContent = <Spinner />;
		}
		else {
			if (this.state.contentDownloadSuccessful) {
				if (this.state.selectedContent === undefined) {
					pageContent = <React.Fragment>
						<div className='content-program-list'>
							<UserConsumer>
								{
									context => context.balance &&
										<div className='content-balance-information'>
											<h1>{Locale.get('content_title')}</h1>
											<span>
												{Locale.get('content_accountBalanceTotal')} <b
													style={
														context.balance.total < 0 ?
															{
																color: 'red'
															} : undefined
													}>
													{context.balance.total}
												</b>
											</span>
											<span>
												{Locale.get('content_accountBalanceAvailable')} <b
													style={
														context.balance.total < 0 ?
															{
																color: 'red'
															} : undefined
													}>{context.balance.total}</b>
											</span>
											<div>{Locale.get('content_accountOrganization')} <b>{context.org}</b></div>
										</div>
								}
							</UserConsumer>
							<hr />
							{
								this.state.contents.map((item) => {
									return <ContentItem key={item.contentId} content={item} onClick={this.onContentItemClicked} />
								})
							}

							<Button variant='primary' onClick={this.onContentEdit}>
								{Locale.get('content_buttonCreate')}
							</Button>
						</div>
					</React.Fragment>;
				}
				else {
					pageContent = (
						<ContentDetailsView content={this.state.selectedContent}
							onBackClicked={this.onContentDetailsViewBackClicked}
							onEditClicked={this.onContentEdit}
						/>
					);
				}
			}
			else {
				pageContent = <div>{Locale.get("content_loadError")}</div>;
			}
		}

		return <Layout>{pageContent}</Layout>;
	}
}